import { createFileRoute } from '@tanstack/react-router';
import { PreviewAccessPage } from '@/features/metric-hub/preview-access/PreviewAccessPage';

export const Route = createFileRoute('/_authed/metric-hub/preview-access')({
  component: PreviewAccessPage,
});
